<template>
  <div
    class="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
    @click.self="$emit('cancel')"
  >
    <div
      class="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg w-1/3"
    >
      <h2 class="font-semibold mb-3 text-gray-900 dark:text-gray-100">
        Select a category for {{ speaker.speaker_name }}
      </h2>
      
      <select
        v-model="selectedCategory"
        :disabled="customCategory.trim().length > 0"
        class="w-full border border-gray-300 dark:border-gray-600 rounded-md shadow-sm p-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-gray-100"
      >
        <option v-for="category in categories" :key="category" :value="category">
          {{ category }}
        </option>
      </select>

      <div class="mt-10 mb-3 font-semibold text-gray-900 dark:text-gray-100">
        Or create your own
      </div>

      <input
        v-model="customCategory"
        type="text"
        placeholder="Keynote Speakers"
        class="mb-8 w-full border border-gray-300 dark:border-gray-600 rounded-md shadow-sm p-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-gray-100"
      />

      <div class="flex justify-end gap-4 mt-4">
        <button
          @click="$emit('cancel')"
          class="px-4 py-2 bg-gray-300 text-gray-700 rounded-md dark:bg-gray-700 dark:text-gray-300"
        >
          Cancel
        </button>
        <button
          @click="confirm"
          class="px-4 py-2 bg-blue-500 text-white rounded-md dark:bg-blue-600 dark:text-gray-100"
        >
          Save
        </button>
      </div>
    </div>
  </div>
</template>
  
  <script>
  export default {
    props: {
      categories: {
        type: Array,
        required: true
      },
      speaker: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        // Represents the selected option from the dropdown.
        selectedCategory: 'No Category',
        // Represents a manually typed out custom category.
        customCategory: ''
      };
    },
    mounted() {
      // Auto-select the first category. This is our default/no category option.
      if (this.categories.length > 0) {
        this.selectedCategory = this.categories[0];
      }
    },
    methods: {
      confirm() {
        // Custom category takes precedence if it's filled in.
        const categoryToEmit = this.customCategory.trim().length > 0
          ? this.customCategory.trim()
          : this.selectedCategory;

        // Allow null through as valid case, meaning no category was selected.
        if (categoryToEmit === '') {
          alert('Please select or enter a category.');
          return;
        }

        this.$emit('confirm', categoryToEmit);
      }
    }
  };
  </script>